// Generated by scripts/generate-public-surface.ts. Do not edit.
export { default as fodselsnummer } from "./fodselsnummer";
export { default as mva } from "./mva";
export { default as orgnr } from "./orgnr";
